const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ============================================================
   Jul 23 2026 — Mobile sticky ATC: full-bar tap target.
   Clarity heatmap showed taps landing on the bar's title/price
   (DIV.mobile-sticky-atc) doing nothing — dead taps. Now any tap
   anywhere on the sticky bar triggers add-to-cart. Taps on the
   actual button are left to its own existing handler in
   sections/main-product.liquid (guard below prevents double-add).
   The bar only exists on mobile product pages, so this is a
   no-op everywhere else.
   ============================================================ */
(function () {
  document.addEventListener('click', function (e) {
    var bar = e.target.closest('.mobile-sticky-atc');
    if (!bar) return;
    if (e.target.closest('[name="add"]')) return; /* button's own handler manages this */
    var form = document.querySelector('product-form');
    var realBtn = form && form.querySelector('[name="add"]');
    if (realBtn) {
      e.preventDefault();
      realBtn.click();
    }
  });
  /* visual affordance: whole bar reads as tappable */
  document.addEventListener('DOMContentLoaded', function () {
    var s = document.createElement('style');
    s.textContent = '.mobile-sticky-atc{cursor:pointer;-webkit-tap-highlight-color:rgba(40,93,78,.12);}';
    document.head.appendChild(s);
  });
})();
